import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Layout/Layout";
import { routes } from "./Routes";

const LayoutRoutes = () => {
  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component }, i) => (
          <Route element={<Layout />} key={i}>
            <Route path={path} element={Component} />
          </Route>
        ))}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
